import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=160ff3da"
import script from "./CommonTable.vue?vue&type=script&lang=js"
export * from "./CommonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports